import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import MoodIcon from '@material-ui/icons/Mood';
import MoodTwoToneIcon from '@material-ui/icons/MoodTwoTone';
import Tooltip from '@material-ui/core/Tooltip';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';

import ChatBoxMessageList from './ChatBoxMessageList';
import ChatBoxCompose from './ChatBoxCompose';
import chatActions from '../actions/chat_actions';
import unreadActions from '../actions/unread_message_actions';
import userActions from '../actions/user_actions';
import windowActions from '../actions/window_actions';

export class ChatBoxTabsWindow extends Component {
    constructor(props) {
        super(props);
        this.child = React.createRef();
        this.button = React.createRef();
        this.state = {
            messages: {},
            chatId: "",
            hub: {},
            channelIdToUserId: {},
            userIdToChannelId: {},
            dateTimeStamp: "",
            tabRecipients: [], // list of tab recipients
            closeIconShown: false,
            closeIconShownIndex: -1,
            currentRecipient: "",
            clickedOnRecipient: {},
            tabIndex: 0,
            currentTabIndex: 0,
            anchorEl: null,
            //setAnchorEl: null,
            flash: true,
            numberOfTabs: 6,
            chatMessageLists: {},
            showMenu: false,
            showDropdownList: false,
        };
    }

    flashNotification = (protocol, action, params) => {
        localStorage.setItem("justLoggedIn", true);
        console.log("[ChatBoxTabsWindow.js] flash protocol called");
        var e = document.createElement('a');
        e.id = 'flashNotification';
        var strParams = "";
        if (typeof params !== 'undefined') {
            Object.keys(params).forEach(function (key) {
                strParams += strParams != "" ? '&' : '';
                strParams += key + '=' + encodeURI(params[key]);
            });
        }
        e.href = strParams.length > 0 ? protocol + '://' + action + '?' + strParams : protocol + '://' + action;
        document.getElementsByTagName('body')[0].appendChild(e);
        e.click();
        e.parentNode.removeChild(e);
    };

    componentDidMount() {
        console.log("chatboxwindow this.props", this.props);
        console.log("recipients: ", this.props.recipients); // should be a list of all the recipients from MemberList

        // Load initial messages
        // this.getChannelMessages(this.props.recipients[0].id); // this needs to be called every time click a tab

        this.setState({ currentRecipient: this.props.recipients[0] });

        // Hub methods
        console.log("local storage token ? ", localStorage.getItem("token") !== null);
        if (localStorage.getItem("token") !== null) {
            this.props.hub.on('NewMessage', (message => {
                console.log("GOT NEW MESSAGE!!!!!");
                console.log(message);
                console.log(this.state);
                if (this.state.channelIdToUserId.hasOwnProperty(message.payload.channelId)) {
                    console.log("CHANNEL IS OPEN");
                    console.log("this.state.channelIdToUserId: ", this.state.channelIdToUserId);
                    var recipientId = this.state.channelIdToUserId[message.payload.channelId];
                    console.log("recipientId: ", recipientId);
                    console.log("messages before: ", this.state.messages[recipientId].length);
                    var updatedMessages = [...this.state.messages[recipientId], { 'createAt': message.payload.createAt, 'userId': message.payload.userId, 'message': message.payload.message }];
                    console.log("messages after: ", updatedMessages.length);
                    var oldMessagesObject = { ...this.state.messages };
                    oldMessagesObject[recipientId] = updatedMessages;
                    this.setState({ 'messages': oldMessagesObject });
                }
                if (message.payload.userId !== this.props.profile.id) {
                    console.log("message.payload.userId: ", message.payload.userId);
                    console.log("this.props.profile.id: ", this.props.profile.id);
                    console.log("INITIATE FLASH");
                    console.log("[ChatBoxTabsWindow] this.props.shouldTurnFlashOn before flashstart", this.props.shouldTurnFlashOn); // false
                    this.flashNotification('teamx', 'flashstart');
                    this.props.setIconFlash(true);
                    console.log("[ChatBoxTabsWindow] this.props.shouldTurnFlashOn after flashstart", this.props.shouldTurnFlashOn); // true
                }
            }));
        }

        var intervalId = setInterval(this.tick, 1000);
        // store intervalId in the state so it can be accessed later:
        this.setState({ intervalId: intervalId });
        // set chat messages to first recipient
        this.handleTabClick(this.props.recipients[0]);
        this.disableUnread(this.props.recipients[0].id);
        this.props.updateTabIndex(0);
    }

    componentWillUnmount = () => {
        // use intervalId from the state to clear the interval
        clearInterval(this.state.intervalId);
    }

    tick = () => {
        this.setState({ 'flash': !this.state['flash'] });
    }

    convertPosts = (posts) => {
        var l = [];
        for (var i = 0; i < posts.length; i++) {
            var post = posts[i];
            l.push({ 'createAt': post.createAt, 'userId': post.userId, 'message': post.message });
        }
        return l;
    }

    getChannelMessages = (recipientId) => {
        // console.log("recipientId: ", recipientId);
        const token = localStorage.token;
        if (token) {
            return fetch("api/Channel/GetMessages", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ 'DisplayName': "", "RecieverId": recipientId })
            })
                .then(resp => resp.json())
                .then(data => {
                    // console.log("GetChannelMessages data: ", data);
                    var newState = { ...this.state };
                    newState['channelIdToUserId'][data.channelId] = recipientId;
                    newState['userIdToChannelId'][recipientId] = data.channelId;
                    newState['messages'][recipientId] = data.posts ? this.convertPosts(data.posts) : [];
                    this.setState(newState);
                });
        }
    }

    sendMessage = (message, createAt) => {
        const token = localStorage.token;
        if (token) {
            var currentRecipient = this.props.recipients[(this.props.currentTabIndex ? this.props.currentTabIndex : 0)].id;
            var request = JSON.stringify({ 'ChannelId': this.state.userIdToChannelId[currentRecipient], 'Message': message, 'RecieverId': currentRecipient, 'CreateAt': createAt });
            fetch("api/post/SendMessage", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: request
            })
                .then(resp => resp.json())
                .then(data => {
                    console.log("DATA FROM SEND_MESSAGE: ", data);
                });
        }
    }

    disableUnreadCallback = () => {
        var currentRecipientId = this.props.recipients[(this.props.currentTabIndex ? this.props.currentTabIndex : 0)].id;
        this.disableUnread(currentRecipientId);
    }

    // appends the new message passed from child ChatBoxCompose
    handleNewMessageCallback = (newMessage) => {
        console.log("new message from child: ", newMessage);
        var currentRecipient = this.props.recipients[(this.props.currentTabIndex ? this.props.currentTabIndex : 0)].id;
        //var newMessages = [...(this.state['messages'][currentRecipient]), newMessage];
        //var newState = { ...this.state['messages'] };
        //newState[currentRecipient] = newMessages;
        // this.setState({ 'messages': newState });
        this.sendMessage(newMessage.message, newMessage.createAt);
    };

    handleTabClick = (recipient, event) => () => {
        console.log("TAB HAS BEEN CLICKED!!!!: ", recipient); // user obj
        console.log("tab's current index: ", this.props.currentTabIndex);
        //call focusTextInput() in child component
        //console.log("this.refs['textField'].getWrappedInstance(): ", this.refs['textField'].getWrappedInstance());
        //this.refs['textField'].getWrappedInstance().focusTextInput();
        //this.child.myInput.focus();
        console.log("this.child", this.child);
        if (this.refs['child' + this.props.currentTabIndex] && this.refs['child' + this.props.currentTabIndex].getWrappedInstance()) {
            this.refs['child' + this.props.currentTabIndex].getWrappedInstance().scrollToBottomDelay();
        }
        this.disableUnread(recipient.id);
        this.setState({ clickedOnRecipient: recipient });
    };

    clickAgain = () => {
        if (this.props.recipients.length >= 1) {
            console.log("TAB HAS BEEN CLICKED AGAIN!!!!"); // user obj
            this.refs['child' + this.props.currentTabIndex].getWrappedInstance().scrollToBottom();
        }
    };

    disableUnread = (recipientId) => {
        this.props.updateRead(recipientId);
        if (this.props.shouldTurnFlashOn) {
            console.log("[disableUnread] this.props.shouldTurnFlashOn before flashstop", this.props.shouldTurnFlashOn); // true
            this.flashNotification('teamx', 'flashstop');
            this.props.setIconFlash(false);
            setTimeout(function () {
                console.log("[disableUnread] this.props.shouldTurnFlashOn after flashstop", this.props.shouldTurnFlashOn);
            }.bind(this), 1000);
        }

        if (this.props.profile.hasOwnProperty('id')) { // current signed in user
            this.props.updateLastSeen(false);
            var l = [];
            for (var property in this.props.unreadMessages) {

                if (property.includes("Object")) {
                    continue;
                }
                if (this.props.unreadMessages[property]) {
                    l.push(property);
                }
            }
            this.props.setUnreadIds(l);
        } else {
            console.log("Don't update since the user isn't logged in");
        }
    };

    handleCloseTab = (recipient) => () => {
        console.log("CLOSE THIS PERSON'S TAB: ", recipient); // user obj; includes status & lastSeen which changes
        this.props.callbackFromParentRemove(recipient); // pass this recipient to parent MemberList
    };

    showCloseIcon = (index) => () => {
        this.setState({ closeIconShownIndex: index });
    };

    hideCloseIcon = () => {
        this.setState({ closeIconShownIndex: -1 });
    };

    // Opens the dropdown menu.
    handleArrowClick = () => {
        this.setState({ showDropdownList: true });
    };

    // Closes the dropdown menu.
    handleArrowClose = () => {
        this.setState({ showDropdownList: false });
    };

    handleMenuTabChange = (index) => () => {
        console.log("Calling tab change from dropdown");
        console.log("index: ", index);
        this.props.callbackFromParent(this.props.recipients[index], false, false, true);
        //console.log("BEFORE IF STATE this.refs['child' + index]", this.refs['child' + index]);
        //console.log("BEFORE IF STATE this.refs['child' + index].getWrappedInstance()", this.refs['child' + index].getWrappedInstance());
        this.setState({}, () => {
            if (this.refs['child' + index] && this.refs['child' + index].getWrappedInstance()) { // this does not get called when index >= 6
                //console.log("this.refs['child' + index]", this.refs['child' + index]);
                //console.log("this.refs['child' + index].getWrappedInstance()", this.refs['child' + index].getWrappedInstance());
                this.refs['child' + index].getWrappedInstance().scrollToBottomDelay();
            }
        });
        this.handleArrowClose();
    };

    render() {

        //const { anchorEl } = this.state;

        let tab = [];
        let tabPanel = [];
        let closeIcon;
        let tabStyle = {};
        let tabListStyle = {};
        //let arrowStyle = { padding: '3px', float: 'right' };
        let awayMessage = "";
        let awayTime = "";
        let awayMessageTime = "";
        let tabName = "";
        let offlineNotification;
        let awayAndOffline;

        let dropdownList =
            <Menu
                id="simple-menu-3"
                anchorEl={this.refs.iconButton}
                keepMounted
                open={this.state.showDropdownList}
                onClose={this.handleArrowClose}
                //style={{ padding: '0px', margin: '0px !important', display: 'grid !important' }}
                MenuListProps={{ style: { padding: '0px', margin: '0px', display: 'grid', height: 'auto' } }}
            >
                {this.props.recipients.map((member, i) => <MenuItem key={i} value={i} onClick={this.handleMenuTabChange(i)} style={{ padding: '0px 5px', fontSize: '13px', minHeight: '25px', overflow: 'hidden', justifyContent: 'left' }}>{member.username}</MenuItem>)} ///
            </Menu>;

        if (this.props.recipients.length > 0) {
            var index = 0;
            this.props.recipients.map((recipientCopy) => {
                var recipient = this.props.memberIdMap[recipientCopy['id']];
                if (!this.state.messages.hasOwnProperty(recipient.id)) {
                    this.getChannelMessages(recipient.id);
                }

                if (this.state.closeIconShownIndex == index) {
                    closeIcon =
                        <IconButton
                            onClick={this.handleCloseTab(recipient)}
                            style={{ padding: '3px' }}
                            size="small"
                        >
                            <CancelIcon style={{ fontSize: '13px' }} />
                        </IconButton>;
                } else {
                    closeIcon = <div></div>;
                }

                // If there is an away message on the recipient object, populate the awayMessage object. Then display it at the bottom under the render.
                if (recipient.awayMessage !== null && recipient.awayMessage !== "") {
                    awayMessage = recipient.awayMessage;
                }
                if (recipient.awayTime !== null && recipient.awayTime !== "") {
                    awayTime = recipient.awayTime;
                }

                // If recipient has away message and is Online, show orange bar in chat window
                if ((recipient.awayMessage !== null && recipient.awayMessage !== "") && (recipient.awayTime !== null && recipient.awayTime !== "") && recipient.status !== "Done") {
                    awayMessageTime =
                        <Grid item xs={12}>
                        <div style={{ textAlign: 'center', backgroundColor: '#ff9400', marginTop: '-10px', position: 'absolute', width: '100%', zIndex: '3' }}>
                                <b>Away message: </b> {awayMessage}<b> - Back by: </b>{awayTime}
                            </div>
                        </Grid>;
                } else {
                    awayMessageTime = <div></div>;
                }

                // If recipient is Offline and does not have away message, show red bar in chat window
                if (recipient.status === "Done" && recipient.inOffice === false && (recipient.awayMessage === "" || recipient.awayMessage === null)) {
                    offlineNotification =
                        <Grid item xs={12}>
                        <div style={{ textAlign: 'center', backgroundColor: '#db6767', marginTop: '-10px', position: 'absolute', width: '100%', zIndex: '3'  }}>
                                <b>User is Offline</b>
                            </div>
                        </Grid>;
                } else {
                    offlineNotification = <div></div>;
                }

                // If recipient has away message AND is Offline, show orange bar and red bar in chat window
                if (recipient.awayMessage !== null && recipient.awayMessage !== "" && recipient.status === "Done" && recipient.inOffice === false) {
                    awayAndOffline =
                        <Grid item xs={12}>
                        <div style={{ textAlign: 'center', backgroundColor: '#db6767', marginTop: '-10px', position: 'absolute', width: '100%', zIndex: '3'  }}>
                                <b>User is Offline</b>
                            </div>
                            <div style={{ textAlign: 'center', backgroundColor: '#ff9400' }}>
                                <b>Away message: </b> {awayMessage}<b> - Back by: </b>{awayTime}
                            </div>
                        </Grid>;
                } else {
                    awayAndOffline = <div></div>;
                }

                if (this.props.unreadMessages[recipient.id] && !this.state['flash'] && index < this.state.numberOfTabs) {
                    tabStyle = { background: '#f7f134', borderRadius: '5px 5px 0px 0px' }; // yellow
                    //tabListStyle = { backgroundColor: '#3f51b5', height: '28px' }; // blue
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                } else if (this.props.unreadMessages[recipient.id] && !this.state['flash'] && index >= this.state.numberOfTabs) {
                    tabStyle = { background: '#f7f134', borderRadius: '5px 5px 0px 0px' }; // yellow
                    //tabListStyle = { backgroundColor: '#3f51b5', height: '28px' }; // blue
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                } else if (this.props.unreadMessages[recipient.id] && this.state['flash'] && index >= this.state.numberOfTabs) {
                    tabStyle = { background: '#f6f6f6', borderRadius: '5px 5px 0px 0px' }; // light grey
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                } else if (recipient.status === "Available" && recipient.inOffice === true && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#4dd691', borderRadius: '5px 5px 0px 0px' }; // green
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                } else if (recipient.status === "Busy" && recipient.inOffice === true && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#ff9400', borderRadius: '5px 5px 0px 0px' }; // orange
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                } else if (recipient.status === "Busy" && recipient.inOffice === false && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#ff9400', borderRadius: '5px 5px 0px 0px' }; // orange
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                } else if (recipient.status === "Done" && recipient.inOffice === false && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#dedede', borderRadius: '5px 5px 0px 0px' }; // grey
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                } else if (recipient.status === "Disconnected" && recipient.inOffice === false && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#dedede', borderRadius: '5px 5px 0px 0px' }; // grey
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                } else {
                    tabStyle = { background: '#f6f6f6', borderRadius: '5px 5px 0px 0px' }; // light grey
                    tabListStyle = { backgroundColor: '#f6f6f6' }; // light grey
                }

                if (index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle['fontWeight'] = 'bold';
                }

                //shortens long names
                var recipientName = recipient.username;
                if (recipient.username.length >= 8) {
                    recipientName = recipientName.slice(0, 8) + "...";
                }
                if (index < this.state.numberOfTabs) {
                    tab.push(
                        <Tab
                            key={recipient.id}
                            onClick={this.handleTabClick(recipient)}
                            onMouseOver={this.showCloseIcon(index)}
                            onMouseLeave={this.hideCloseIcon}
                            style={tabStyle}
                        >
                            {recipientName}
                            {closeIcon}
                        </Tab>
                    );
                    tabPanel.push(
                        <TabPanel key={recipient.id} forceRender={true} onClick={() => this.disableUnread(recipient.id)}>
                            <div onClick={this.props.onClick}>
                                <Grid container spacing={0} style={{}}>
                                    {awayMessageTime}
                                    {offlineNotification}
                                    {awayAndOffline}
                                    <Grid container item xs={12} spacing={0}>
                                        <Grid item xs={12}>
                                            <ChatBoxMessageList callbackFromParentClick={this.clickAgain} recipient={recipient} ref={'child' + index} messages={this.state.messages[recipient.id] ? this.state.messages[recipient.id] : []} />
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={12} spacing={0} style={{}}>
                                        <ChatBoxCompose ref={(ch) => this.child = ch} messages={this.state.messages[recipient.id] ? this.state.messages[recipient.id] : []} callbackFromParent={this.handleNewMessageCallback} unreadCallback={this.disableUnreadCallback} />
                                    </Grid>
                                </Grid>
                            </div>
                        </TabPanel>
                    );
                }

                index++;
            });
        }

        return (
            <div>
                <Tabs
                    selectedIndex={this.props.currentTabIndex ? this.props.currentTabIndex : 0}
                    onSelect={tabIndex => this.props.updateTabIndex(tabIndex)}
                    // style={{ height: 'auto !important', overflow: 'hidden !important' }}
                >
                    <TabList
                        //style={{ backgroundColor: '#3f51b5', height: '28px' }}
                        style={tabListStyle}
                    >
                        {/*<TabList style={{ backgroundColor: '#f6f6f6', height: '28px' }}>*/}

                        {tab}

                        {/*
                         <IconButton
                            title={'Dropdown'}
                            aria-owns={this.state.anchorEl ? 'simple-menu-3' : undefined}
                            //aria-controls="simple-menu-3"
                            aria-haspopup="true"
                            onClick={this.handleArrowClick}
                            style={{ padding: '3px', float: 'right' }}
                            >
                            <ArrowDropDownIcon style={{ fontSize: '20px' }} />
                        </IconButton>
           
                        <Menu
                            id="simple-menu-3"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={Boolean(this.state.anchorEl)}
                            onClose={this.handleArrowClose}
                            style={{ padding: '0px' }}
                            MenuListProps={{ style: { padding: '0px' } }}
                        >
                            {this.props.recipients.map((member, i) => <MenuItem key={i} value={i} onClick={this.handleMenuTabChange(i)} style={{ padding: '0px 5px', fontSize: '13px', minHeight: '25px' }}>{member.username}</MenuItem>)}
                        </Menu>
                        */}

                        <IconButton
                            title={'Dropdown'}
                            aria-owns={this.state.showDropdownList ? 'simple-menu-3' : undefined}
                            aria-controls="simple-menu-3"
                            aria-haspopup="true"
                            // onClick={this.handleArrowClick} does not work
                            style={{ padding: '3px', float: 'right' }}
                            ref='iconButton'
                            //ref={el => (this.button = el)}
                        >
                            <ArrowDropDownIcon style={{ fontSize: '20px' }} />
                        </IconButton>

                        {this.state.showDropdownList && dropdownList}

                    </TabList>
                    {tabPanel}
                </Tabs>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        hub: state.hub,
        members: state.members,
        profile: state.profile,
        memberIdMap: state.memberIdMap,
        currentUser: state.currentUser,
        unreadMessages: state.unreadMessages,
        currentTabIndex: state.currentTabIndex,
        shouldTurnFlashOn: state.shouldTurnFlashOn,
    };
}

const mapDispatchToProps = dispatch => ({
    updateRead: (userId) => dispatch(userActions['READ_MESSAGE'](userId)),
    updateTabIndex: (tabIndex) => dispatch(chatActions['TAB_INDEX'](tabIndex)),
    setWindowAutoClose: shouldAutoClose => dispatch(windowActions['ALLOW_WINDOW_AUTO_CLOSE'](shouldAutoClose)),
    setUnreadIds: unreadIds => dispatch(unreadActions['SET_UNREAD_IDS'](unreadIds)),
    setIconFlash: shouldTurnFlashOn => dispatch(windowActions['SET_ICON_FLASH'](shouldTurnFlashOn)),
    updateLastSeen: (updateStamp) => dispatch(userActions['UPDATE_LAST_SEEN'](updateStamp))
})

export default connect(mapStateToProps, mapDispatchToProps)(ChatBoxTabsWindow);


// WEBPACK FOOTER //
// ./src/components/ChatBoxTabsWindow.js
/*
export class ChatBoxTabsWindow extends Component {
    constructor(props) {
        super(props);
        this.child = React.createRef();
        this.button = React.createRef();
        this.state = {
            messages: {},
            chatId: "",
            hub: {},
            channelIdToUserId: {},
            userIdToChannelId: {},
            dateTimeStamp: "",
            tabRecipients: [], // list of tab recipients
            closeIconShown: false,
            closeIconShownIndex: -1,
            currentRecipient: "",
            clickedOnRecipient: {},
            tabIndex: 0,
            currentTabIndex: 0,
            anchorEl: null,
            //setAnchorEl: null,
            flash: true,
            numberOfTabs: 6,
            chatMessageLists: {},
            showMenu: false,
            showDropdownList: false,
        };
    }

    flashNotification = (protocol, action, params) => {
        localStorage.setItem("justLoggedIn", true);
        console.log("[ChatBoxTabsWindow.js] flash protocol called");
        var e = document.createElement('a');
        e.id = 'flashNotification';
        var strParams = "";
        if (typeof params !== 'undefined') {
            Object.keys(params).forEach(function (key) {
                strParams += strParams != "" ? '&' : '';
                strParams += key + '=' + encodeURI(params[key]);
            });
        }
        e.href = strParams.length > 0 ? protocol + '://' + action + '?' + strParams : protocol + '://' + action;
        document.getElementsByTagName('body')[0].appendChild(e);
        e.click();
        e.parentNode.removeChild(e);
    };
    //
    onresize = (e) => {
        this.setState({ windowWidth: e.target.innerWidth }, () => {
            if (this.state.windowWidth < 290) {
                window.open("", "ChatBoxWindow").resizeTo(304, 539);
            }
        });
    };
    /
    //
    unload = () => {
        console.log("unload");
        console.log("screenX: ", window.open("", "ChatBoxWindow").screenX);
        console.log("screenY: ", window.open("", "ChatBoxWindow").screenY);
        var chatWindowScreenX = window.open("", "ChatBoxWindow").screenX;
        var chatWindowScreenY = window.open("", "ChatBoxWindow").screenY;
        localStorage.setItem("chatWindowScreenX", chatWindowScreenX);
        localStorage.setItem("chatWindowScreenY", chatWindowScreenY);
        console.log(localStorage.getItem("chatWindowScreenX"));
        console.log(localStorage.getItem("chatWindowScreenY"));
    };
    //
    componentDidMount() {
        window.open("", "ChatBoxWindow").addEventListener("resize", this.onresize);
        console.log("recipients: ", this.props.recipients); // should be a list of all the recipients from MemberList
        console.log("chatboxwindow this.props", this.props);

        // Load initial messages
        this.getChannelMessages(this.props.recipients[0].id); // this needs to be called every time click a tab
        this.setState({ currentRecipient: this.props.recipients[0] });

        // Hub methods
        if (localStorage.getItem("token") !== null) {
            this.props.hub.on('NewMessage', (message => {
                console.log("GOT NEW MESSAGE!!!!!");
                console.log(message);
                console.log(this.state);
                if (this.state.channelIdToUserId.hasOwnProperty(message.payload.channelId)) {
                    console.log("CHANNEL IS OPEN");
                    console.log("this.state.channelIdToUserId: ", this.state.channelIdToUserId);
                    var recipientId = this.state.channelIdToUserId[message.payload.channelId];
                    console.log("recipientId: ", recipientId);
                    console.log("messages before: ", this.state.messages[recipientId].length);
                    var updatedMessages = [...this.state.messages[recipientId], { 'createAt': message.payload.createAt, 'userId': message.payload.userId, 'message': message.payload.message }];
                    console.log("messages after: ", updatedMessages.length);
                    var oldMessagesObject = { ...this.state.messages };
                    oldMessagesObject[recipientId] = updatedMessages;
                    this.setState({ 'messages': oldMessagesObject });
                }
                if (message.payload.userId !== this.props.profile.id) {
                    console.log("message.payload.userId: ", message.payload.userId);
                    console.log("this.props.profile.id: ", this.props.profile.id);
                    console.log("INITIATE FLASH");
                    console.log("[ChatBoxTabsWindow] this.props.shouldTurnFlashOn before flashstart", this.props.shouldTurnFlashOn); // false
                    this.flashNotification('teamx', 'flashstart');
                    this.props.setIconFlash(true);
                    console.log("[ChatBoxTabsWindow] this.props.shouldTurnFlashOn after flashstart", this.props.shouldTurnFlashOn); // true
                }
            }));
        }

        var intervalId = setInterval(this.tick, 1000);
        // store intervalId in the state so it can be accessed later:
        this.setState({ intervalId: intervalId });

        // set chat messages to first recipient
        this.handleTabClick(this.props.recipients[0]);
        this.disableUnread(this.props.recipients[0].id);
        this.props.updateTabIndex(0);
        window.open("", "ChatBoxWindow").addEventListener("beforeunload", this.unload);
    }

    componentWillUnmount = () => {
        // use intervalId from the state to clear the interval
        clearInterval(this.state.intervalId);
    }

    tick = () => {
        this.setState({ 'flash': !this.state['flash'] });
    }

    convertPosts = (posts) => {
        var l = [];
        for (var i = 0; i < posts.length; i++) {
            var post = posts[i];
            l.push({ 'createAt': post.createAt, 'userId': post.userId, 'message': post.message });
        }
        return l;
    }

    getChannelMessages = (recipientId) => {
        console.log("recipientId: ", recipientId);
        const token = localStorage.token;
        if (token) {
            return fetch("api/Channel/GetMessages", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ 'DisplayName': "", "RecieverId": recipientId })
            })
                .then(resp => resp.json())
                .then(data => {
                    console.log("GetChannelMessages data: ", data);
                    var newState = { ...this.state };
                    newState['channelIdToUserId'][data.channelId] = recipientId;
                    newState['userIdToChannelId'][recipientId] = data.channelId;
                    newState['messages'][recipientId] = data.posts ? this.convertPosts(data.posts) : [];
                    this.setState(newState);
                });
        }
    }

    sendMessage = (message, createAt) => {
        const token = localStorage.token;
        if (token) {
            var currentRecipient = this.props.recipients[(this.props.currentTabIndex ? this.props.currentTabIndex : 0)].id;
            var request = JSON.stringify({ 'ChannelId': this.state.userIdToChannelId[currentRecipient], 'Message': message, 'RecieverId': currentRecipient, 'CreateAt': createAt });
            fetch("api/post/SendMessage", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: request
            })
            .then(resp => resp.json())
            .then(data => {
                console.log("DATA FROM SEND_MESSAGE ", data);
            });
        }
    }
    //
    flashNotification = (protocol, action, params) => {
        console.log("flash protocol called");
        var e = document.createElement('a');
        e.id = 'flashNotification';
        var strParams = "";
        if (typeof params !== 'undefined') {
            Object.keys(params).forEach(function (key) {
                strParams += strParams != "" ? '&' : '';
                strParams += key + '=' + encodeURI(params[key]);
            });
        }
        e.href = strParams.length > 0 ? protocol + '://' + action + '?' + strParams : protocol + '://' + action;
        document.getElementsByTagName('body')[0].appendChild(e);
        e.click();
        e.parentNode.removeChild(e);
    };
    //

    disableUnreadCallback = () => {
        var currentRecipientId = this.props.recipients[(this.props.currentTabIndex ? this.props.currentTabIndex : 0)].id;
        this.disableUnread(currentRecipientId);
    }

    // appends the new message passed from child ChatBoxCompose
    handleNewMessageCallback = (newMessage) => {
        console.log("new message from child: ", newMessage); // logs first: logs the correct createAt
        // var currentRecipient = this.props.recipients[(this.props.currentTabIndex ? this.props.currentTabIndex : 0)].id;
        // var newMessages = [...(this.state['messages'][currentRecipient]), newMessage];
        // var newState = { ...this.state['messages'] };
        // newState[currentRecipient] = newMessages;
        // this.setState({ 'messages': newState });
        this.sendMessage(newMessage.message, newMessage.createAt);
    };

    handleTabClick = (recipient, event) => () => {
        console.log("TAB HAS BEEN CLICKED!!!!: ", recipient); // user obj
        console.log("tab's current index: ", this.props.currentTabIndex);
        //call focusTextInput() in child component
        //console.log("this.refs['textField'].getWrappedInstance(): ", this.refs['textField'].getWrappedInstance());
        //this.refs['textField'].getWrappedInstance().focusTextInput();
        //this.child.myInput.focus();
        console.log("this.child", this.child);
        if (this.refs['child' + this.props.currentTabIndex] && this.refs['child' + this.props.currentTabIndex].getWrappedInstance()) {
            // this.refs['child' + this.props.currentTabIndex].getWrappedInstance().scrollToBottomDelay();
        }
        this.disableUnread(recipient.id);
        this.setState({ clickedOnRecipient: recipient });
    };
     
    clickAgain = () => {
        if (this.props.recipients.length >= 1) {
            console.log("TAB HAS BEEN CLICKED AGAIN!!!!"); // user obj
            this.refs['child' + this.props.currentTabIndex].getWrappedInstance().scrollToBottom();
        }
    };

    disableUnread = (recipientId) => {
        this.props.updateRead(recipientId); // updateRead: (userId) => dispatch(userActions['READ_MESSAGE'](userId)),
        console.log("Unread Messages...");
        if (this.props.shouldTurnFlashOn) {
            console.log("[disableUnread] this.props.shouldTurnFlashOn before flashstop", this.props.shouldTurnFlashOn); // true
            this.flashNotification('teamx', 'flashstop');
            this.props.setIconFlash(false);
            setTimeout(function () {
                console.log("[disableUnread] this.props.shouldTurnFlashOn after flashstop", this.props.shouldTurnFlashOn);
            }.bind(this), 1000);
        }
        if (this.props.profile.hasOwnProperty('id')) { // current signed in user
            this.props.;updateLastSeen(false);
            var l = [];
            for (var property in this.props.unreadMessages) {

                if (property.includes("Object")) {
                    continue;
                }
                if (this.props.unreadMessages[property]) {
                    l.push(property);
                }
            }
            this.props.setUnreadIds(l);
        } else {
            console.log("Don't update since the user isn't logged in");
        }
        // Stop flash here
        //
        this.flashNotification('teamx', 'flashstop');
        setTimeout(function () {
            this.forceUpdate();
        }.bind(this), 1000);
        //
    };

    handleCloseTab = (recipient) => () => {
        console.log("CLOSE THIS PERSON'S TAB: ", recipient); // user obj; includes status & lastSeen which changes
        this.props.callbackFromParentRemove(recipient); // pass this recipient to parent MemberList
    };

    showCloseIcon = (index) => () => {
        this.setState({ closeIconShownIndex: index });
    };

    hideCloseIcon = () => {
        this.setState({ closeIconShownIndex: -1 });
    };

    // Opens the dropdown menu.
    handleArrowClick = () => {
        this.setState({ showDropdownList: !this.state.showDropdownList });
    };

    // Closes the dropdown menu.
    handleArrowClose = () => {
        this.setState({ showDropdownList: false });
    };

    handleMenuTabChange = (index) => () => {
        console.log("Calling tab change from dropdown");
        console.log("index: ", index);
        this.props.callbackFromParent(this.props.recipients[index], false, false, true);
        //console.log("BEFORE IF STATE this.refs['child' + index]", this.refs['child' + index]);
        //console.log("BEFORE IF STATE this.refs['child' + index].getWrappedInstance()", this.refs['child' + index].getWrappedInstance());
        this.setState({}, () => {
            if (this.refs['child' + index] && this.refs['child' + index].getWrappedInstance()) { // this does not get called when index >= 6
                //console.log("this.refs['child' + index]", this.refs['child' + index]);
                //console.log("this.refs['child' + index].getWrappedInstance()", this.refs['child' + index].getWrappedInstance());
                this.refs['child' + index].getWrappedInstance().scrollToBottomDelay();
            }
        });
        this.handleArrowClose();
    };

    render() {
        let tab = [];
        let tabPanel = [];
        let closeIcon;
        let tabStyle = {};
        let tabListStyle = {};
        //let arrowStyle = { padding: '3px', float: 'right' };
        let awayMessage = "";
        let awayTime = "";
        let awayMessageTime = "";
        let tabName = "";
        let offlineNotification;
        let awayAndOffline;

        let dropdownList =
            <Menu
                id="simple-menu-3"
                anchorEl={this.refs.iconButton}
                keepMounted
                open={this.state.showDropdownList}
                onClose={this.handleArrowClose}
                //style={{ padding: '0px', margin: '0px !important', display: 'grid !important' }}
                MenuListProps={{ style: { padding: '0px', margin: '0px', display: 'grid' } }}
            >
                {this.props.recipients.map((member, i) => <MenuItem key={i} value={i} onClick={this.handleMenuTabChange(i)} style={{ padding: '0px 5px', fontSize: '13px', minHeight: '25px', justifyContent: 'left' }}>{member.username}</MenuItem>)}
            </Menu>;

        if (this.props.recipients.length > 0) {
            var index = 0;
            this.props.recipients.map((recipientCopy) => {
                var recipient = this.props.memberIdMap[recipientCopy['id']];
                if (!this.state.messages.hasOwnProperty(recipient.id)) {
                    this.getChannelMessages(recipient.id);
                }

                if (this.state.closeIconShownIndex == index) {
                    closeIcon =
                        <IconButton
                            onClick={this.handleCloseTab(recipient)}
                            style={{ padding: '1px', paddingLeft: '8px' }}
                            size="small"
                        >
                            <CancelIcon style={{ fontSize: '13px' }} />
                        </IconButton>;
                } else {
                    closeIcon = <div></div>;
                }

                // If there is an away message on the recipient object, populate the awayMessage object. Then display it at the bottom under the render.
                if (recipient.awayMessage !== null && recipient.awayMessage !== "") {
                    awayMessage = recipient.awayMessage;
                }
                if (recipient.awayTime !== null && recipient.awayTime !== "") {
                    awayTime = recipient.awayTime;
                }

                // If recipient has away message and is Online, show orange bar in chat window
                if ((recipient.awayMessage !== null && recipient.awayMessage !== "") && (recipient.awayTime !== null && recipient.awayTime !== "") && recipient.status !== "Done") {
                    awayMessageTime =
                        <Grid item xs={12}>
                            <div style={{ textAlign: 'center', backgroundColor: '#ff9400', marginTop: '-10px' }}>
                                <b>Away message: </b> {awayMessage}<b> - Back by: </b>{awayTime}
                            </div>
                        </Grid>;
                } else {
                    awayMessageTime = <div></div>;
                }

                // If recipient is Offline and does not have away message, show red bar in chat window
                if (recipient.status === "Done" && recipient.inOffice === false && (recipient.awayMessage === "" || recipient.awayMessage === null)) {
                    offlineNotification =
                        <Grid item xs={12}>
                            <div style={{ textAlign: 'center', backgroundColor: '#db6767', marginTop: '-10px' }}>
                                <b>User is Offline</b>
                            </div>
                        </Grid>;
                } else {
                    offlineNotification = <div></div>;
                }

                // If recipient has away message AND is Offline, show orange bar and red bar in chat window
                if (recipient.awayMessage !== null && recipient.awayMessage !== "" && recipient.status === "Done" && recipient.inOffice === false) {
                    awayAndOffline =
                        <Grid item xs={12}>
                            <div style={{ textAlign: 'center', backgroundColor: '#db6767', marginTop: '-10px' }}>
                                <b>User is Offline</b>
                            </div>
                            <div style={{ textAlign: 'center', backgroundColor: '#ff9400' }}>
                                <b>Away message: </b> {awayMessage}<b> - Back by: </b>{awayTime}
                            </div>
                        </Grid>;
                } else {
                    awayAndOffline = <div></div>;
                }

                if (this.props.unreadMessages[recipient.id] && !this.state['flash'] && index < this.state.numberOfTabs) {
                    tabStyle = { background: '#f7f134', borderRadius: '5px 5px 0px 0px' }; // yellow
                    //tabListStyle = { backgroundColor: '#3f51b5', height: '28px' }; // blue
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                } else if (this.props.unreadMessages[recipient.id] && !this.state['flash'] && index >= this.state.numberOfTabs) {
                    tabStyle = { background: '#f7f134', borderRadius: '5px 5px 0px 0px' }; // yellow
                    //tabListStyle = { backgroundColor: '#3f51b5', height: '28px' }; // blue
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                } else if (this.props.unreadMessages[recipient.id] && this.state['flash'] && index >= this.state.numberOfTabs) {
                    tabStyle = { background: '#f6f6f6', borderRadius: '5px 5px 0px 0px' }; // light grey
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                } else if (recipient.status === "Available" && recipient.inOffice === true && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#4dd691', borderRadius: '5px 5px 0px 0px' }; // green
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                } else if (recipient.status === "Busy" && recipient.inOffice === true && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#ff9400', borderRadius: '5px 5px 0px 0px' }; // orange
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                } else if (recipient.status === "Busy" && recipient.inOffice === false && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#ff9400', borderRadius: '5px 5px 0px 0px' }; // orange
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                } else if (recipient.status === "Done" && recipient.inOffice === false && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#dedede', borderRadius: '5px 5px 0px 0px' }; // grey
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                } else if (recipient.status === "Disconnected" && recipient.inOffice === false && index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle = { background: '#dedede', borderRadius: '5px 5px 0px 0px' }; // grey
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                } else {
                    tabStyle = { background: '#f6f6f6', borderRadius: '5px 5px 0px 0px' }; // light grey
                    tabListStyle = { backgroundColor: '#f6f6f6', height: '28px' }; // light grey
                }

                if (index === (this.props.currentTabIndex ? this.props.currentTabIndex : 0)) {
                    tabStyle['fontWeight'] = 'bold';
                }

                //shortens long names
                var recipientName = recipient.username;
                if (recipient.username.length > 9) {
                    recipientName = recipientName.slice(0, 8) + "...";
                }

                if (index < this.state.numberOfTabs) {
                    tab.push(
                        <Tab
                            key={recipient.id}
                            onClick={this.handleTabClick(recipient)}
                            onMouseOver={this.showCloseIcon(index)}
                            onMouseLeave={this.hideCloseIcon}
                            style={tabStyle}
                        >
                            {recipient.firstName}
                            {closeIcon}
                        </Tab>
                    );
                    tabPanel.push(
                        <TabPanel key={recipient.id} forceRender={true} onClick={() => this.disableUnread(recipient.id)}>
                            {awayMessageTime}
                            {offlineNotification}
                            {awayAndOffline}
                            <div onClick={this.props.onClick}>
                                <Grid container direction="column" spacing={0} style={{ flexGrow: '1' }}>
                                    <Grid item xs={12} style={{ marginTop: '0px', padding: '0 10px 10px 10px', maxHeight: '275px', maxWidth: '100%', overflowY: 'auto', overflowWrap: 'break-word' }}>
                                        <ChatBoxMessageList callbackFromParentClick={this.clickAgain} recipient={recipient} ref={"child" + index} messages={this.state.messages[recipient.id] ? this.state.messages[recipient.id] : []} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <ChatBoxCompose ref={(ch) => this.child = ch} messages={this.state.messages[recipient.id] ? this.state.messages[recipient.id] : []} callbackFromParent={this.handleNewMessageCallback} unreadCallback={this.disableUnreadCallback}/>
                                    </Grid>
                                </Grid>
                            </div>
                        </TabPanel>
                    );
                }

                index++;
            });
        }
        return (
            <div ref={this.chatBoxFocus}>
                <Tabs
                    selectedIndex={this.props.currentTabIndex ? this.props.currentTabIndex : 0}
                    onSelect={tabIndex => this.props.updateTabIndex(tabIndex)}
                >
                    <TabList style={{ backgroundColor: '#f6f6f6', height: '35px' }}>
                        {tab}
                        <IconButton
                            title={'Dropdown'}
                            aria-owns={this.state.showDropdownList ? 'simple-menu-3' : undefined}
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            onClick={this.handleArrowClick}
                            ref='iconButton'
                            // style={arrowStyle}
                            >
                            <ArrowDropDownIcon style={{ fontSize: '20px' }} />
                        </IconButton>
                        {//this.state.showDropdownList && dropdownList//}
                       
                        <Menu
                            id="simple-menu"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={Boolean(this.state.anchorEl)}
                            onClose={this.handleClose}
                            style={{ padding: '0px' }}
                        >
                            {this.props.recipients.map((member, i) => <MenuItem key={i} value={i} onClick={this.handleMenuTabChange(i)} style={{ padding: '5px 10px', fontSize: '13px' }}>{member.firstName}</MenuItem>)}
                        </Menu>
                        
                    </TabList>
                    {tabPanel}
                </Tabs>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        hub: state.hub,
        members: state.members,
        profile: state.profile,
        memberIdMap: state.memberIdMap,
        currentUser: state.currentUser,
        unreadMessages: state.unreadMessages,
        currentTabIndex: state.currentTabIndex,
        shouldTurnFlashOn: state.shouldTurnFlashOn,
    };
}

const mapDispatchToProps = dispatch => ({
    updateRead: (userId) => dispatch(userActions['READ_MESSAGE'](userId)),
    updateTabIndex: (tabIndex) => dispatch(chatActions['TAB_INDEX'](tabIndex)),
    setWindowAutoClose: shouldAutoClose => dispatch(windowActions['ALLOW_WINDOW_AUTO_CLOSE'](shouldAutoClose)),
    setUnreadIds: unreadIds => dispatch(unreadActions['SET_UNREAD_IDS'](unreadIds)),
    setIconFlash: shouldTurnFlashOn => dispatch(windowActions['SET_ICON_FLASH'](shouldTurnFlashOn)),
    updateLastSeen: (updateStamp) => dispatch(userActions['UPDATE_LAST_SEEN'](updateStamp))
})

export default connect(mapStateToProps, mapDispatchToProps)(ChatBoxTabsWindow);
*/


// WEBPACK FOOTER //
// ./src/components/ChatBoxTabsWindow.js